import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {LogService} from "./log.service";
import { v4 as uuidv4 } from 'uuid';
import {LANG} from "../tokens/lang.token";
import {LanguageService} from "./language.service";
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  headers : HttpHeaders;
  constructor(public http: HttpClient, public logger : LogService, public langService: LanguageService) {
    this.headers =  new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      "Access-Control-Allow-Headers" : "Content-Type",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PATCH"
    })
  }

  get<T>(url: string, params: any = undefined,unique:boolean=true,bypass:boolean=false){
    const urlSearchParams = new URLSearchParams();
    if(params){
      for (const [key, value] of Object.entries(params)) {
        if(Array.isArray(value)){
          urlSearchParams.set(key,JSON.stringify(value))
        } else {
          urlSearchParams.set(key,value as string)
        }
      }
    }
    urlSearchParams.set('lang',this.langService.current);
    if(!unique){
      urlSearchParams.set('state',uuidv4());
    }
    if(bypass){
      urlSearchParams.set("ngsw-bypass","true");
    }
     url = `${url}?${urlSearchParams.toString()}`;
    return new Promise<T>((resolve,reject)=>{
      lastValueFrom<T>(this.http.get<T>(`${url}`))
        .then((data:T)=>{
          this.logger.logHttpCallback(url,data);
          resolve(data);
        })
        .catch((err:any)=>{
          this.logger.logHttpCallbackError(`${url} : ${err.toString()}`);
          reject(err);
        })
    });
  }

  post<T>(url: string, params: any = {}){
    params.lang = this.langService.current
    return new Promise<T>((resolve,reject)=>{
      lastValueFrom<T>(this.http.post<T>(url,params))
        .then((data:T)=>{
          this.logger.logHttpCallback(url,data);
          resolve(data);
        })
        .catch((err:any)=>{
          this.logger.logHttpCallbackError(`${url} : ${err.toString()}`);
          reject(err);
        })
    });
  }
}
